import { render, staticRenderFns } from "./BlogsAd.vue?vue&type=template&id=2ecf5c51&"
import script from "./BlogsAd.vue?vue&type=script&lang=js&"
export * from "./BlogsAd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports